import { Instance, types } from 'mobx-state-tree';

export const AttachmentModel = types.model({
  id: types.number,
  file: types.string,
  createdAt: types.string,
});

export const ContactUsModel = types.model({
  id: types.number,
  name: types.string,
  email: types.string,
  country: types.string,
  city: types.string,
  message: types.string,
  createdAt: types.string,
  updatedAt: types.string,
  attachments: types.optional(types.array(AttachmentModel), []),
});

export type ContactMessage = Instance<typeof ContactUsModel>
